import { DOMAIN_DEFINITION_ID, GROUP_DEFINITION_ID, PERMISSION_DEFINITION_ID } from '@hypercharge/lambda-utils/lib/constants';
export { InternalHandlers } from './lambdas/invoke-internal-handler/types';
export const CMS_TENANT_PERMISSION = 'CMS';
export const BULK_EDIT_PERMISSION = 'BULK_EDIT';
export const CMS_EXPORT_PERMISSION = 'CMS_EXPORT';
export const CMS_DEFAULT_ITEM_META_HANDLER = 'cms';
export const TITLE_PROPERTY_ID = 'title';
export const CREATED_AT_PROPERTY_ID = 'createdAt';
export const UPDATED_AT_PROPERTY_ID = 'updatedAt';
export const ENTITY_ID_PROPERTY_ID = 'entityId';
export const ENTITY_OWNER_PROPERTY_ID = 'entityOwner';
export const ENTITY_DOMAIN_PROPERTY_ID = 'entityDomain';
export const CONTACT_GROUPS_PROPERTY_ID = 'groups';
export const PARENT_GROUP_PROPERTY_ID = 'parentGroup';
export const LOCATION_PROPERTY_ID = 'location';
export const HOBBIES_PROPERTY_ID = 'hobbiesList';
export const CUSTOMER_TYPE_PROPERTY_ID = 'customerType';
export const COMMERCIAL_TYPE_PROPERTY_ID = 'commercialType';
export const EXTERNAL_REF_ID_PROPERTY_ID = 'externalRefId';
export const OWNER_GROUP_PLACEHOLDER = '__owner__';
export const DOMAIN_GROUP_PREFIX = '__domain__';
export const OWNER_IS_GROUP_PREFIX = 'ownerIs__';
export const DEFINITION_ID = 'definitionId';
export const DEFINITION_ES_PROPERTY_ID = 'definitionId';
export const DEFAULT_SAFE_MAX_CONCURRENCY = 5; // should not be bigger than sql max connections
export const COUNTRY_DEFINITION_ID = 'country';
export const LANGUAGE_DEFINITION_ID = 'language';
export const GENDER_DEFINITION_ID = 'gender';
export const SALUTATION_DEFINITION_ID = 'salutation';
export const VIEW_DEFINITION_ID = 'view';
export const LOCATION_DEFINITION_ID = 'location';
export const CONTACT_HOBBIES_DEFINITION_ID = 'contactHobbies';
export const CUSTOMER_TYPE_DEFINITION_ID = 'customerType';
export const COMMERCIAL_TYPE_DEFINITION_ID = 'commercialType';
export const HYPER_BI_DASHBOARDS_DEFINITION_ID = 'hyperBiDashboards';
export const APPS_DEFINITION_ID = 'apps';
export const ES_SYSTEM_ENTITIES_INDEX = 'systemEntities';
export const OWNER_AND_DOMAIN_FREE_DEFINITION_IDS = [
    COUNTRY_DEFINITION_ID,
    DOMAIN_DEFINITION_ID,
    GROUP_DEFINITION_ID,
    LANGUAGE_DEFINITION_ID,
    PERMISSION_DEFINITION_ID
];
export const OWNER_AND_DOMAIN_PROPERTY_IDS = [
    ENTITY_DOMAIN_PROPERTY_ID,
    ENTITY_OWNER_PROPERTY_ID,
    'entityDomains'
];
export const DEFAULT_ES_SEARCH_LIMIT = 500;
export const MAX_ES_SEARCH_LIMIT = 10000;
//# sourceMappingURL=constants.js.map